// extracted by mini-css-extract-plugin
module.exports = {"main":"App_main__3ZkGI","navContents":"App_navContents__xKoFy"};